<template>
  <Footer :columns="columns">
    <FooterOfficeInformation />
  </Footer>
</template>

<script>
import Footer from 'chimera/all/themes/blueflow/components/layout/Footer'
import FooterOfficeInformation from 'chimera/all/themes/blueflow/components/layout/FooterOfficeInformation'

export default {
  components: {
    Footer,
    FooterOfficeInformation,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      columns: [
        {
          title: 'Over ons',
          links: [
            {
              text: 'Contact',
              to: '/contact-opnemen',
            },
          ],
        },
        {
          title: 'Professionals',
          links: [
            {
              text: 'Aanmelden als pro',
              to: '/contact-opnemen-bedrijf',
            },
          ],
        },
        {
          title: 'Consumenten',
          links: [
            {
              text: 'Informatie over warmtepompen',
              to: '/informatie-over-warmtepompen',
            },
          ],
        },
      ],
    }
  },
}
</script>
